import { render } from "./Pagination.vue?vue&type=template&id=589e0a2e&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=589e0a2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-589e0a2e"

export default script